import './Subskills.scss';

import { useEffect, useMemo, useState } from 'react';
import useCreateScreening from '../../hooks/useCreateScreening';
import { t } from '../../i18n/i18n';
import { inHtmlTag } from '../../utils/inHtmlTag';
import ModalSubmission from '../ModalSubmission/ModalSubmission';
import SearchIcon from '../../assets/screening/SearchIcon';
import MultipleSelect from '../MultipleSelect/MultipleSelect';
import profileImageNull from '../../assets/profile/profile.png';

import {
  createSubskill,
  deleteSubskill,
  getSubskills,
  getSubskillsAll,
  updateSubskills,
} from '../../API/services/screeningService';
import { notification } from 'antd';
import { SubskillRow } from './SubskillRow';
import { DeleteSubskillModal } from './modal/DeleteSubskillModal';
import NewSubskillModal from './modal/NewSubskillModal';
import UpdateSubskillModal from './modal/UpdateSubskillModal';
import { ConfirmModal } from './modal/ConfirmModal';
import ImportSubskillsModal from './modal/ImportSubskillsModal';
import useTranslations from '../../hooks/useTranslations';
import { AutoScroll } from '../AutoScroll/AutoScroll';

const RowSelected = ({ subskill, onClickCancel = () => {} }) => (
  <div
    className="test-button-filters-selected d-flex justify-content-between align-items-center"
    style={{ backgroundColor: '#3A6EA5', color: 'white' }}
  >
    <div className="ml-2">
      <img
        className="user-heading-img rounded-circle p-"
        style={{ width: '50px', height: '50px', filter: 'invert(1)' }}
        src={subskill?.iconUrl || profileImageNull}
        alt={t('PROFILE_MENU_LOGO_USER')}
      />
    </div>
    <div className="m-2">
      <span style={{ color: 'white' }}>{subskill?.name}</span>
    </div>
    <div>
      <button
        type="button"
        data-testid="create-evaluation-second-step-button"
        className={`bg-transparent p-2 d-flex m-2 justify-content-center align-items-center  ${'test-button-filters'}`}
        style={{ borderColor: '#FFFF' }}
        onClick={onClickCancel}
      >
        <span
          className={` test-text-filters ${'test-text-filters-selected'}`}
          data-testid="create-evaluation-ss-filters-selected-span"
          style={{ color: 'white' }}
        >
          {t('SELECTED')}
        </span>
      </button>
    </div>
  </div>
);

const RowSwap = ({
  currentSubskill,
  onClickSetSubskillSelected = () => {},
  subskillSelected,
  canSelect = true,
  onClickCancel = () => {},
  onAddSubskill = () => {},
  onRemoveSubskill = () => {},
  setModalDelete = () => {},
  onSelectSubskillToUpdate = () => {},
  onDragStart = () => {},
  onDragOver = () => {},
  onDrop = () => {},
  onDragEnd = () => {},
  overThis = false,
  draggable = false,
  buttonPlus = false,
}) => (
  <div
    draggable={draggable}
    onDrop={onDrop}
    onDragOver={onDragOver}
    onDragStart={onDragStart}
    onDragEnd={onDragEnd}
    style={{ outline: overThis ? '2px solid green' : '', cursor: draggable ? 'grab' : '' }}
  >
    {currentSubskill?.id === subskillSelected?.id ? (
      <RowSelected subskill={currentSubskill} onClickCancel={onClickCancel} />
    ) : (
      <SubskillRow
        subskill={currentSubskill}
        onClickSetSubskillSelected={onClickSetSubskillSelected}
        subskillSelected={subskillSelected}
        canSelect={canSelect}
        onAddSubskill={onAddSubskill}
        onRemoveSubskill={onRemoveSubskill}
        setModalDelete={setModalDelete}
        onSelectSubskillToUpdate={onSelectSubskillToUpdate}
        buttonPlus={buttonPlus}
      />
    )}
  </div>
);

const Subskills = () => {
  const [subskillSelected, setSubskillSelected] = useState(null);
  const [itemDragging, setItemDragging] = useState(null);
  const [itemOver, setItemOver] = useState(null);
  const [subskills, setSubskills] = useState([]);
  const [allSubskills, setAllSubskills] = useState([]);
  const [subSubskills, setSubSubskills] = useState([]);
  const [subSubskills2, setSubSubskills2] = useState([]);
  const [subskillToUpdate, setSubskillToUpdate] = useState(null);
  const [showModalDelete, setShowModalDelete] = useState(null);
  const [subskillToDelete, setSubskillToDelete] = useState(null);
  const [showModalToCreate, setShowModalToCreate] = useState(null);
  const [showModalImport, setShowModalImport] = useState(false);
  const [filter, setFilter] = useState({ name: '' });
  const { key } = useTranslations();
  const [modalConfirm, setModalConfirm] = useState({
    title: '',
    description: '',
    show: false,
    subskill: {},
    onSubmit: () => {},
  });

  const updateModalConfirm = (data) => {
    setModalConfirm({ ...modalConfirm, ...data });
  };
  const sortParents = (array = []) =>
    array.sort((a, b) => {
      if (a.parentId === null) return -1;
      if (b.parentId === null) return 1;
      return Number(a.parentId) - Number(b.parentId);
    });

  const loadSubskillsColumns = (responseSubskills, nameFilter = '') => {
    let subskillsCopy = responseSubskills?.filter((item) => !item?.parent);

    let subSubskillsCopy = responseSubskills?.filter(
      (item) => item?.parent && !item?.parent?.parentId
    );
    sortParents(subSubskillsCopy);

    let subSubskills2Copy = responseSubskills?.filter(
      (item) => item?.parent && item?.parent?.parentId
    );

    sortParents(subSubskills2Copy);

    if (nameFilter) {
      const funcFilter = (item) =>
        item?.id === subskillSelected?.id ||
        item?.name?.toLowerCase()?.includes(nameFilter?.toLowerCase()) ||
        (item?.languages && item?.languages[key]?.includes(nameFilter?.toLowerCase()));
      subskillsCopy = subskillsCopy?.filter(funcFilter);
      subSubskillsCopy = subSubskillsCopy?.filter(funcFilter);
      subSubskills2Copy = subSubskills2Copy?.filter(funcFilter);
    }

    setSubskills(subskillsCopy);
    setSubSubskills(subSubskillsCopy);
    setSubSubskills2(subSubskills2Copy);
    setSubskillToUpdate(null);
    if (subskillSelected) {
      const findSelected = responseSubskills?.find((item) => item?.id === subskillSelected?.id);
      setSubskillSelected(findSelected);
    }
  };

  const init = async () => {
    const responseSubskills = await getSubskillsAll();
    setAllSubskills(responseSubskills);
    loadSubskillsColumns(responseSubskills, filter?.name);
  };

  const onSelectSubskillToUpdate = (subskill) => {
    setSubskillToUpdate(subskill);
  };

  useEffect(() => {
    init();
  }, []);

  const onClickSetSubskillSelected = (subskill) => {
    setSubskillSelected(subskill);
  };

  const onClickCancel = () => {
    setSubskillSelected(null);
  };
  const alertSuccesss = (message = t('SUBSKILL_UPDATED_MESSAGE')) => {
    notification.success({
      message,
      type: 'success',
    });
  };
  const alertError = (messaje = t('ACTION_CANCELLED')) => {
    notification.error({
      message: messaje,
      type: 'error',
    });
  };
  const onAddSubskill = async ({ parent, subskillToAdd }) => {
    if (subskillToAdd?.children?.length > 0) {
      alertError(
        t('SUBSKILL_ASSOCIATES').replace(
          '{{name}}',
          subskillToAdd?.languages
            ? subskillToAdd?.languages[key] ?? subskillToAdd?.name
            : subskillToAdd?.name
        )
      );
      return;
    }
    if (subskillToAdd?.id === parent?.id) {
      alertError();
      return;
    }

    try {
      const response = await updateSubskills(subskillToAdd?.id, { parentId: parent?.id });
      await init();
      alertSuccesss();
    } catch (error) {
      alertError('NO_UPDATED');
    }
  };
  const confirmOnSubmit = ({ subskill, parentId }) => {
    updateSubskills(subskill?.id, { parentId })
      .then((response) => {
        init();
        alertSuccesss();
      })
      .catch(() => alertError(t('NO_UPDATED')))
      .finally(() => updateModalConfirm({ show: false }));
  };

  const onRemoveSubskill = ({ subskillToRemove }) => {
    const parentId = subskillToRemove?.parent?.parentId ?? null;

    if (subskillToRemove?.children?.length > 0) {
      updateModalConfirm({
        show: true,
        onSubmit: () => confirmOnSubmit({ subskill: subskillToRemove, parentId }),
        subskill: subskillToRemove,
        title: t('DO_YOU_WANT_CONTINUE'),
        description: t('SUBSKILL_ASSOCIATES')?.replace('{{name}}', subskillToRemove?.name),
      });
    } else {
      confirmOnSubmit({ subskill: subskillToRemove, parentId });
    }
  };

  const createNewSubskill = (_newSubskill, newFile) => {
    createSubskill({ ..._newSubskill, parentId: null }, newFile)
      .then((response) => {
        if (!response) {
          alertError();
          return;
        }
        init();
        alertSuccesss();
      })
      .catch(() => alertError())
      .finally(() => setShowModalToCreate(false));
  };
  const updateSubskill = (_updateSubskill, updateFile) => {
    updateSubskills(subskillToUpdate?.id, { ..._updateSubskill }, updateFile)
      .then((response) => {
        if (!response) {
          alertError();
          return;
        }
        init();
        alertSuccesss();
      })
      .catch(() => alertError())
      .finally(() => setShowModalToCreate(false));
  };

  const onDeleteSubskill = () => {
    deleteSubskill(subskillToDelete?.id)
      .then((response) => {
        if (!response) {
          alertError(t('SUBSKILL_CANCELLED_MESSAGE'));
          return;
        }
        alertSuccesss(t('DELETED_SUCCESS'));
        setShowModalDelete(false);
        init();
      })
      .catch(() => {
        alertError(t('SUBSKILL_CANCELLED_MESSAGE'));
        setShowModalDelete(false);
      });
  };
  const onClickDeleteSubskill = (_subskillToDelete) => {
    setShowModalDelete(true);
    setSubskillToDelete(_subskillToDelete);
  };

  const onClickShowModal = (subskill, show) => {
    setShowModalDelete(show);
    setSubskillToDelete(subskill);
  };

  const handleInput = (e) => {
    loadSubskillsColumns(allSubskills, e?.target?.value);
    setFilter({ ...filter, name: e?.target?.value });
  };

  const exportSubskillsToCSV = () => {
    const headers = ['ID', 'Name (ES)', 'Name (EN)', 'Name (PT)', 'Parent ID'];
    const rows = allSubskills.map((subskill) => {
      const nameEs = subskill.languages?.es || subskill.name || '';
      const nameEn = subskill.languages?.en || '';
      const namePt = subskill.languages?.pt || '';
      const parentId = subskill.parentId || '';

      return [
        subskill.id,
        `"${nameEs.replace(/"/g, '""')}"`,
        `"${nameEn.replace(/"/g, '""')}"`,
        `"${namePt.replace(/"/g, '""')}"`,
        parentId,
      ].join(',');
    });

    const csvContent = [headers.join(','), ...rows].join('\n');
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', `subskills_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    notification.success({
      message: t('CSV_EXPORTED_SUCCESS'),
      type: 'success',
    });
  };

  return (
    <div data-testid="create-evaluation-second-step" className="d-flex flex-column h-100">
      <AutoScroll isDragging={itemDragging} scrollAreaHeight={500} />
      <span
        className="font-weight-600  create-evaluation-step-title text-light-black mb-3"
        data-testid="create-evaluation-ss-title-span"
      >
        {t('SUBSKILL_PAGE_TITLE')}
      </span>
      <div className="d-flex">
        <span
          className=" font-weight-600 text-base text-light-black justify-content-start"
          data-testid="create-evaluation-ss-test-title-span"
        >
          {t('SUBSKILL_QUESTION')}
        </span>
        <div className="flex-fill" />
      </div>

      <span className="text-light-black font-weight-400 text-base my-2 ">
        {t('SUBSKILL_DESCRIPTION_PAGE')}
        <p className="text-light-black font-weight-400 text-base my-2 ">
          {t('SUBSKILL_DESCRIPTION_OPTION1_PAGE')}
        </p>
        <p className="text-light-black font-weight-400 text-base my-2 ">
          {t('SUBSKILL_DESCRIPTION_OPTION2_PAGE')}
        </p>
        <p className="text-light-black font-weight-400 text-base my-2 ">
          {t('SUBSKILL_DESCRIPTION_OPTION3_PAGE')}
        </p>
      </span>

      <div className="test-button-filters-selected d-flex justify-content-between align-items-center my-3 w-100">
        <div className="d-flex justify-content-start">
          <div className="w-100">
            {' '}
            <button
              type="button"
              data-testid="create-evaluation-second-step-button"
              className={` p-2 d-flex m-2 justify-content-center align-items-center  ${'test-button-filters'}`}
              style={{ backgroundColor: '#449cc8' }}
              onClick={() => setShowModalToCreate(true)}
            >
              <span
                className={` test-text-filters ${'test-text-filters-selected'} text-white`}
                data-testid="create-evaluation-ss-filters-selected-span"
              >
                {t('NEW_SUBSKILL')}
              </span>
            </button>
            <button
              type="button"
              data-testid="export-subskills-csv-button"
              className={` p-2 d-flex m-2 justify-content-center align-items-center  ${'test-button-filters'}`}
              style={{ backgroundColor: '#28a745' }}
              onClick={() => exportSubskillsToCSV()}
            >
              <span
                className={` test-text-filters ${'test-text-filters-selected'} text-white`}
                data-testid="export-subskills-csv-span"
              >
                {t('EXPORT_CSV')}
              </span>
            </button>
            <button
              type="button"
              data-testid="import-subskills-csv-button"
              className={` p-2 d-flex m-2 justify-content-center align-items-center  ${'test-button-filters'}`}
              style={{ backgroundColor: '#17a2b8' }}
              onClick={() => setShowModalImport(true)}
            >
              <span
                className={` test-text-filters ${'test-text-filters-selected'} text-white`}
                data-testid="import-subskills-csv-span"
              >
                {t('IMPORT_CSV')}
              </span>
            </button>
          </div>
          <div
            className="d-flex align-items-center justify-content-start pr-4 w-100"
            style={{ minWidth: 300 }}
          >
            <div
              className={`my-1 my-sm-0 rounded transition-2-ms p-2 d-flex align-items-center w-100 tests-search-input-full bg-white `}
            >
              <SearchIcon testid="alkemy-tests-search-icon" />
              <input
                onChange={handleInput}
                value={filter?.name}
                className=" text-xs w-100 bg-transparent border-0 outline-none ml-2"
                style={{ flex: '1' }}
                placeholder={t('SUBSKILL_ABM_SEARCH_PLACEHOLDER')}
                type="text"
                data-testid="alkemy-tests-search-input"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="w-100 mx-auto h-100 bg-gray p-4 d-flex justify-content-around"
        style={{ gap: 10 }}
      >
        <div className="w-100 ">
          <h2 className="text-center mb-2 ">{t('COLUMN_SUBSKILL')}</h2>
          <div
            className="border border-1 border-grey w-100 d-flex flex-column p-2"
            style={{ gap: 10 }}
          >
            {subskills?.map((item, index) => (
              <RowSwap
                key={index}
                currentSubskill={item}
                subskillSelected={subskillSelected}
                onClickSetSubskillSelected={onClickSetSubskillSelected}
                onClickCancel={onClickCancel}
                onAddSubskill={onAddSubskill}
                setModalDelete={onClickShowModal}
                onSelectSubskillToUpdate={onSelectSubskillToUpdate}
                onDragStart={(e) => {
                  setItemDragging(item);
                  setSubskillSelected(item);
                }}
                onDragOver={(e) => {
                  e.preventDefault();
                  setItemOver(item);
                }}
                onDragEnd={(e) => {
                  e.preventDefault();
                  setItemOver(null);
                  setItemDragging(null);
                }}
                onDrop={(e) => {
                  onAddSubskill({ parent: item, subskillToAdd: itemDragging });
                }}
                overThis={itemOver?.id === item?.id}
                draggable={subskillSelected && subskillSelected?.id === item?.id}
              />
            ))}
          </div>
        </div>
        <div className="w-100 ">
          <h2 className="text-center">{t('COLUMN_SUBSUBSKILL')}</h2>
          <div
            className="border border-1 border-grey w-100 d-flex flex-column p-2"
            style={{ gap: 10 }}
          >
            {subSubskills?.map((item, index) => (
              <RowSwap
                key={index}
                currentSubskill={item}
                subskillSelected={subskillSelected}
                onClickSetSubskillSelected={onClickSetSubskillSelected}
                onClickCancel={onClickCancel}
                onAddSubskill={onAddSubskill}
                onRemoveSubskill={onRemoveSubskill}
                setModalDelete={onClickShowModal}
                onSelectSubskillToUpdate={onSelectSubskillToUpdate}
                onDragStart={(e) => {
                  setItemDragging(item);
                  setSubskillSelected(item);
                }}
                onDragOver={(e) => {
                  e.preventDefault();
                  setItemOver(item);
                }}
                onDragEnd={(e) => {
                  e.preventDefault();
                  setItemOver(null);
                  setItemDragging(null);
                }}
                onDrop={(e) => {
                  onAddSubskill({ parent: item, subskillToAdd: itemDragging });
                }}
                overThis={itemOver?.id === item?.id}
                draggable={subskillSelected && subskillSelected?.id === item?.id}
              />
            ))}
          </div>
        </div>
        <div className="w-100 ">
          <h2 className="text-center">{t('COLUMN_SUBSUBSKILL_2')}</h2>
          <div
            className="border border-1 border-grey w-100 d-flex flex-column p-2"
            style={{ gap: 10 }}
          >
            {subSubskills2?.map((item, index) => (
              <RowSwap
                key={index}
                currentSubskill={item}
                subskillSelected={subskillSelected}
                onClickSetSubskillSelected={onClickSetSubskillSelected}
                onClickCancel={onClickCancel}
                onAddSubskill={onAddSubskill}
                onRemoveSubskill={onRemoveSubskill}
                setModalDelete={onClickShowModal}
                onSelectSubskillToUpdate={onSelectSubskillToUpdate}
                onDragStart={(e) => {
                  setItemDragging(item);
                  setSubskillSelected(item);
                }}
                onDragOver={(e) => {
                  e.preventDefault();
                  setItemOver(item);
                }}
                onDragEnd={(e) => {
                  e.preventDefault();
                  setItemOver(null);
                  setItemDragging(null);
                }}
                onDrop={(e) => {
                  alertError();
                }}
                draggable={subskillSelected && subskillSelected?.id === item?.id}
              />
            ))}
          </div>
        </div>
      </div>
      {showModalDelete && (
        <DeleteSubskillModal
          showModal={showModalDelete}
          setShowModal={setShowModalDelete}
          submitAction={onDeleteSubskill}
          subskillToDelete={subskillToDelete}
        />
      )}
      {showModalToCreate && (
        <NewSubskillModal
          showModal={showModalToCreate}
          setShowModal={setShowModalToCreate}
          onSubmit={createNewSubskill}
        />
      )}
      {subskillToUpdate && (
        <UpdateSubskillModal
          showModal={subskillToUpdate}
          setShowModal={(value) => !value && setSubskillToUpdate(null)}
          onSubmit={updateSubskill}
          onClickDeleteSubskill={onClickDeleteSubskill}
          subskillToUpdate={subskillToUpdate}
        />
      )}
      <ConfirmModal
        showModal={modalConfirm.show}
        subskill={modalConfirm?.subskill}
        setShowModal={(value) => updateModalConfirm({ show: value })}
        submitAction={modalConfirm?.onSubmit}
        title={modalConfirm.title}
        description={modalConfirm.description}
      />
      {showModalImport && (
        <ImportSubskillsModal
          showModal={showModalImport}
          setShowModal={setShowModalImport}
          onSuccess={init}
        />
      )}
    </div>
  );
};

export default Subskills;
